<template>
  <div class="medical-order">
    <el-form :model="medicalForm"
             :rules="rules"
             ref="medicalFormRef"
             label-width="120px"
             class="demo-medicalForm">

      <el-form-item label="是否开启分账"
                    prop="is_open">
        <el-switch v-model="medicalForm.is_open"
                   :active-value="1"
                   :inactive-value="0"></el-switch>
      </el-form-item>

      <el-form-item label="分账账户"
                    prop="sub_mid">
        <el-select style="width: 330px;"
                   v-model="medicalForm.sub_mid"
                   placeholder="请选择">
          <el-option v-for="item in configList"
                     :key="item.key"
                     :label="item.name"
                     :value="item.key"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <el-button type="primary"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('727') : false"
                   @click="saveForm('medicalFormRef')">保 存</el-button>
        <el-button @click="resetForm('medicalFormRef')"
                   :disabled=" module_id_array[0] ? !module_id_array.includes('727') : false">取 消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import system from '../../../api/system';
export default {
  props: {
    configList: {
      type: Array,
      require: true,
      default: function () {
        return [];
      }
    }
  },
  data() {
    return {
      medicalForm: {
        is_open: '',
        sub_mid: ''
      },
      rules: {
        is_open: [{ required: true, message: '请选择', trigger: 'change' }],
        sub_mid: [{ required: true, message: '请选择', trigger: 'change' }]
      }
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    }
  },
  created() {
    this.getChinaums();
  },
  methods: {
    getChinaums() {
      if (this.module_id_array[0] && !this.module_id_array.includes('726')) {
        return;
      }
      system.getChinaumsPhysical().then((res) => {
        let { code, data } = res;
        if (code == 0) {
          this.medicalForm = data.info;
        }
      });
    },
    saveForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          system.setChinaumsPhysical(this.medicalForm).then((res) => {
            let { code } = res;
            if (code == 0) {
              this.$message.success('保存成功');
              this.getChinaums();
            }
          });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    }
  }
};
</script>

<style lang="scss">
.medical-order {
  .demo-medicalForm {
    & > div {
      display: flex;
      .el-form-item__content {
        margin-left: 20px !important;
      }
    }
  }
}
</style>